<template>
  <div>
    <Toolbar>
      <v-toolbar-title>{{title}}</v-toolbar-title>
      <v-btn flat icon color="gray" @click="$emit('refresh')">
        <v-icon>cached</v-icon>
      </v-btn>
      <v-spacer></v-spacer>
      <v-text-field
        v-model="search"
        append-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-btn flat icon color="grey" @click="$emit('customHeader')">
        <v-icon>settings</v-icon>
      </v-btn>
      <v-btn color="accent" @click.stop="saveOrEdit(null, 'new')"> <v-icon>add</v-icon> </v-btn>
    </Toolbar>
    <v-data-table
      :headers="headers"
      :items="data"
      :search="search"
    >
    <template v-slot:headers="props">
      <tr class="primary">
        <td v-for="(header, i) in headers" :class="textAlign(header)" :key ="`${header.text}-${i}`">{{header.text}}</td>
      </tr>
    </template>
      <template v-slot:items="props">
        <tr class="primary">
        <td v-for="(header, i) in headers" :key ="`${header.text}-${i}`" :class="textAlign(header)" @click="selectRow(props.item)"> 
          <span v-if="header.value === 'action'">
            <v-btn v-for="action in header.action" icon @click.stop="saveOrEdit(props.item, action)" >
            <v-icon small>
              {{action}}
            </v-icon>
            </v-btn>
          </span>
          
          <span v-else>
            {{props.item[header.value]}}
          </span>
          </td>
          </tr>
      </template>
      <template v-slot:no-data>
        No Data
      </template>
    </v-data-table>
  </div>
</template>

<script>
  export default {
    props: {
      title: String,
      headers: {
        type: Array,
        required: true
      },
      data: {
        type: Array,
        required: true
      }
    },
    data: () => ({
      search: '',
      isDark: false
    }),
    methods: {
      saveOrEdit (item, action) {
        this.$emit('action', {
          item,
          action
        })
      },
      selectRow(item)  {
        this.$emit('selection', item)
      },
      textAlign(header) {
        if(header.align === 'right')
          return 'text-xs-right'
        if(header.align === 'center')
          return 'text-xs-center'
        return 'text-xs-left'
      }
    }
  }
</script>
